import * as apiClient from "./httpCommon";
import { apiRoutes } from "../helper";

export const getAllSchools = async (data) => (await apiClient.postAPICall(apiRoutes.superAdmin.getAllSchools, data)).data;
export const getSchoolById = async (data) => (await apiClient.postAPICall(apiRoutes.superAdmin.getSchoolById, data)).data;
export const saveSchool = async (data) => (await apiClient.postAPICall(apiRoutes.superAdmin.saveSchool, data)).data;
export const inviteAdminUser = async (data) => (await apiClient.postAPICall(apiRoutes.superAdmin.inviteAdminUser, data)).data;
